import { Result } from '@restless/sanitizers';
import { utils } from 'ethers';
export var asEthAddress = function (value, path) {
    try {
        if (typeof value === 'string') {
            return Result.ok(utils.getAddress(value));
        }
    }
    catch (_a) { } // tslint:disable-line
    return Result.error([{ path: path, expected: 'ethereum address' }]);
};
